import md5 from 'md5';
import * as moment from 'moment';
import * as _ from 'underscore';
import i18n from '../i18n';
import validate from './validate';
import { Auth } from 'aws-amplify';

import 'moment/locale/es';
import Swal from 'sweetalert2';
import BuxService from '../Service/BuxService';
import RatingsService from '../Service/RatingsService';
import Session from '../Service/Session';
import StatesService from '../Service/StatesService';
import UserService from '../Service/UserService';
import { logPageView } from './analytics';
const APP_STRING = window.AppStrings;
const DD_MMM_YYYY = 'DD-MMM-YYYY';

/**
 * Update Form state object
 * @param  name
 * @param  value
 * @param  stateObject
 * @param  formElement
 */
export function updateFormStateObject(name, value, stateObject, formElement) {
	formElement.value = value;
	const [isValid, errorMsg] = validate(value, formElement.validationRules);
	formElement.isValid = isValid;
	formElement.error_text = errorMsg;
	stateObject[name] = formElement;
	let formIsValid = true;
	for (const obj of Object.values(stateObject)) {
		formIsValid = obj.isValid && formIsValid;
	}
	return [stateObject, formIsValid];
}

/**
 * Validate All Form Fields
 * @param form
 */
// eslint-disable-next-line max-statements
export function formValidator(form) {
	let isFormValid = false;
	let formElements = form;
	const fields = Object.keys(formElements);
	for (const field of fields) {
		const name = field;
		const value = formElements[name].value;
		const formElement = {
			...formElements[name]
		};
		formElement.isTouched = true;
		const [updatedForm, isFormElementValid] = updateFormStateObject(name, value, formElements, formElement);
		formElements = updatedForm;
		isFormValid = isFormElementValid;
	}
	return [formElements, isFormValid];
}

/**
 * This function is used for Logging messages.
 * @param val
 * @constructor
 */
export function LogMessage(val) {
	if (window.AppConfig.DEBUG) {
		if (typeof val === 'object') {
			// eslint-disable-next-line no-console
		}
		// eslint-disable-next-line no-console
	}
}

/**
 * This function is used for Logging errors.
 * @param val
 * @constructor
 */
export function LogError(val) {
	if (window.AppConfig.DEBUG) {
		if (typeof val === 'object') {
			// eslint-disable-next-line no-console
			console.error(JSON.stringify(val));
		}
		// eslint-disable-next-line no-console
		console.error(val);
	}
}

/**
 * This function is used to check Response data from Server.
 * @param response
 * @return {*}
 * @constructor
 */
export function CheckResponse(response) {
	if (response.body) {
		if (typeof response.body !== 'undefined') {
			return typeof response.body === 'string' ? JSON.parse(response.body).data : response.body.data;
		}
		return response.body;
	}
	return response;
}

/**
 * This function returns date from javascript Date() object
 */
export function GetDate(date) {
	return moment(date).utc().format('YYYY-MM-DD');
}
/**
 * This function to append the format of date
 */

export function convertToViewableDate(date) {
	return moment(date).format('MM/DD/YYYY');
}

export function GetFormat(date) {
	return moment(date).locale(i18n.t('date.format')).format(DD_MMM_YYYY).toUpperCase();
}

export function convertToPhilippinesTime(date) {
	moment.locale('en');
	const utcDate = moment.utc(date);
	const philippinesDate = utcDate.utcOffset(8); // UTC+8
	return philippinesDate.format('DD-MMM-YYYY hh:mm A');
}

export function GetFormatLoanAgreement(date) {
	return moment(date).locale(i18n.t('en')).format(DD_MMM_YYYY);
}

/**
 * This function returns date from javascript Date() object
 */
export function GetUtcDate(date) {
	return moment(date).utc();
}

/**
 * This function check if is object null or string empty
 */
export function isObjectNull(value) {
	if (typeof value === 'string') {
		return value === '';
	}
	if (typeof value === 'object') {
		return value === null;
	}
	return true;
}

/**
 * This function is used for generate user avatar
 */
export function getAvatar(email, size) {
	return 'https://www.gravatar.com/avatar/' + md5(email) + '.jpg?s=' + size;
}

/**
 * This function is used for find next date
 */
export function findNextDate(currentDate, frequency) {
	const cDate = moment(currentDate).locale(i18n.t('en'));
	switch (frequency) {
		case 'WEEK':
			return cDate.add(1, 'week').format(DD_MMM_YYYY);
		case 'TWO_WEEK':
			return cDate.add(2, 'week').format(DD_MMM_YYYY);
		case 'MONTH':
			return cDate.add(1, 'month').format(DD_MMM_YYYY);
		case 'QUARTER':
			return cDate.add(1, 'quarter').format(DD_MMM_YYYY);
		case 'YEAR':
			return cDate.add(1, 'year').format(DD_MMM_YYYY);
		default:
			return cDate.format(DD_MMM_YYYY);
	}
}

export function checkIfLender(currentUser, loan) {
	return (
		(loan.created_by === currentUser && loan.loan_type === 'LEND') ||
		(loan.created_by !== currentUser && loan.loan_type === 'BORROW')
	);
}

export function removeCountryCode(phone) {
	if (phone.charAt(1) === '9' || phone.charAt(1) === '4' || phone.charAt(1) === '3') {
		return phone.slice(3);
	} else {
		return phone.slice(2);
	}
}

export function getCountryCode(phone) {
	if (phone.charAt(1) === '9') {
		return '+91';
	} else if (phone.charAt(1) === '4') {
		return '+44';
	} else if (phone.charAt(1) === '3') {
		return '+34';
	} else {
		return '+63';
	}
}

export function checkIfStateOrCommonwealth(lenderState) {
	if (lenderState === 'KY' || lenderState === 'MA' || lenderState === 'VA' || lenderState === 'PA') {
		return 'Commonwealth';
	} else if (
		lenderState === 'FM' ||
		lenderState === 'GU' ||
		lenderState === 'MH' ||
		lenderState === 'MP' ||
		lenderState === 'PR' ||
		lenderState === 'PW' ||
		lenderState === 'VI'
	) {
		return 'Territory';
	} else {
		return 'State';
	}
}

export function checkIfPastDate(date) {
	return moment(date).diff(moment(), 'day') < 0;
}

export function removeSpecialCharacters(phoneNumber) {
	return phoneNumber.replace(/[\s+()-]/g, '');
}

export async function whenUserLoggedIn(props, logURL, nextScreen) {
	const currentUser = await Auth.currentSession();
	Session.setAccessToken(currentUser.getIdToken().getJwtToken());
	const currentUserInfo = await Auth.currentUserInfo();
	const userProfile = await UserService.getCurrentUser();
	BuxService.buxAuthToken();
	const rating = await RatingsService.getUserRating(userProfile.id, '');
	if (userProfile && userProfile.state) {
		const stateData = await StatesService.getStateById(userProfile.state);
		if (stateData && stateData.name) {
			userProfile.state_name = stateData.name;
		}
	}
	const typeObj = { type: 'getObject' };
	const idData = await UserService.signedUrlUploadId(userProfile.id, typeObj);
	currentUserInfo.profile = userProfile;
	Session.store(APP_STRING.CURRENT_USER_INFO, currentUserInfo);

	Session.store(APP_STRING.RATING, rating);
	Session.store(APP_STRING.UPLOAD_ID, idData);

	props.setCurrentUser(currentUserInfo);
	logPageView(logURL); // NOSONAR

	if (userProfile.account && userProfile.account.plaid_status === 'ITEM_LOGIN_REQUIRED') {
		const lang = localStorage.getItem('i18nextLng');
		await i18n.changeLanguage(lang);
		window.Swal.fire({
			html: i18n.t('sweetalert.text_for_reauthentication_required'),
			icon: 'warning',
			showCancelButton: true,
			allowOutsideClick: false,
			confirmButtonColor: '#3085d6',
			cancelButtonColor: '#d33',
			cancelButtonText: i18n.t('buttons.cancel'),
			confirmButtonText: i18n.t('buttons.validate_your_bank_account'),
			customClass: 'otp_message_success'
		}).then(result => {
			if (result.value) {
				window.openDwollaPlaid(() => {
					deleteNavigationalWindowObject();
					window.openScreen('HOME');
				});
			} else {
				props.openScreen('HOME');
			}
		});
		return;
	}

	if (props.user.emailId !== '') {
		props.onCloseWhenLoanExists();
	} else if (
		props.props.match.path === '/loan/:id' ||
		props.props.match.path === '/amortization-table/:id' ||
		props.props.match.path === '/modify-loan/:id' ||
		props.props.match.path === '/profile'
	) {
		props.setInitialScreen();
	} else {
		props.openScreen(nextScreen);
	}
}

export function ucFirst(text) {
	return text.charAt(0).toUpperCase() + text.toLowerCase().slice(1);
}

export function getReasonsOfFailure(reasonsArray) {
	const reasons = _.pluck(reasonsArray, 'description');
	let allReasons = '';
	_.map(reasons, function (reason) {
		allReasons = allReasons + reason + ', ';
	});
	return allReasons;
}

export function getFrequency(frequency) {
	if (frequency === 'TWO WEEK') {
		return 'Every Two Weeks';
	} else if (frequency === 'LUMP_SUM') {
		return 'Lump Sum';
	} else {
		return frequency.charAt(0).toUpperCase() + frequency.toLowerCase().slice(1) + 'ly';
	}
}

export function returnInitialsFromFullName(name = '') {
	var initials = name.match(/\b\w/g) || [];
	initials = ((initials.shift() || '') + (initials.pop() || '')).toUpperCase();
	return initials;
}

export function convertToLangKey(key = '') {
	var result = key.toLowerCase().replace(/([A-Z])/g, ' $1');
	return result.split(' ').join('_').toLowerCase();
}

export function setNavigationalWindowObject(data) {
	window.dataForPopUp = data;
}

export function getNavigationalWindowObject() {
	return window.dataForPopUp;
}

export function deleteNavigationalWindowObject() {
	delete window.dataForPopUp;
}

export function checkIfPastOrPresentDate(date) {
	return moment(date).diff(moment(), 'day') < 0 || moment().isSame(date, 'day');
}

export function checkIfDateGreaterThanMaximumDate(date, maxDate) {
	return moment(GetDate(date)).diff(GetDate(maxDate)) > 0;
}

export function checkIfDateIsOfPast(date) {
	return moment(date).diff(moment(), 'day') < 0;
}

/**
 *
 * @param {*} amount
 * @returns US formatted amount
 */
export function amountFormate(amount) {
	let formattedAmount = amount;

	if (typeof amount === 'string') {
		formattedAmount = Number(amount).toFixed(2);
	}

	// return Number(formattedAmount.toFixed(2)).toLocaleString("en-US");
	return CommaSeparator(Number(formattedAmount).toFixed(2));
}

export const numberWithCommas = x => x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');

export function CommaSeparator(value) {
	let finalValue;

	if (typeof value === 'number' && !isNaN(value)) {
		if (Number.isInteger(value)) {
			finalValue = value.toLocaleString();
		} else {
			const [integerPart, decimalPart] = value.toFixed(2).toString().split('.');
			finalValue = `${parseInt(integerPart, 10).toLocaleString()}.${decimalPart}`;
		}
	} else if (typeof value === 'string' && !isNaN(Number(value))) {
		const numberValue = parseFloat(value);
		if (Number.isInteger(numberValue)) {
			finalValue = numberValue.toLocaleString();
		} else {
			const [integerPart, decimalPart] = numberValue.toFixed(2).toString().split('.');
			finalValue = `${parseInt(integerPart, 10).toLocaleString()}.${decimalPart}`;
		}
	} else if (typeof value === 'undefined') {
		return null;
	} else {
		finalValue = value;
	}

	return finalValue;
}

export const onChangeCommaSeperator = value => {
	const newValue = value.replace(/,/g, '');
	const numericValue = newValue.replace(/[^0-9]/g, '');
	const finalValue = numericValue.replace(/\B(?=(\d{3})+(?!\d))/g, ',');

	return finalValue;
};

export async function getSessionRemainngTime() {
	try {
		const session = await Auth.currentSession();

		const expirationTime = new Date(session.getIdToken().getExpiration() * 1000);

		const currentTime = new Date();
		const remainingTimeInSeconds = (expirationTime - currentTime) / 1000;

		const remainingHours = Math.floor(remainingTimeInSeconds / 3600);
		const remainingMinutes = Math.floor((remainingTimeInSeconds % 3600) / 60);
		const remainingSeconds = Math.floor(remainingTimeInSeconds % 60);

		return {
			remainingHours,
			remainingMinutes,
			remainingSeconds
		};
	} catch (error) {
		console.error('Error retrieving session information:', error);
	}
}

export async function SessionPopUpReminder() {
	const { remainingHours, remainingMinutes, remainingSeconds } = await getSessionRemainngTime();
	const message = `Session expires in ${remainingHours} hours, ${remainingMinutes} minutes, and ${remainingSeconds} seconds`;

	Swal.fire({
		title: 'Session Reminder!',
		text: `${message}, Click ok to extend your session or cancel to logout`,
		allowOutsideClick: false,
		icon: 'warning',
		customClass: 'otp_message_success',
		showCancelButton: true
	}).then(res => {
		if (res.value) {
			window.location.reload();
		} else {
			window.location.href = '/logout';
		}
	});
}

function save(url, activity) {
	const token = localStorage.getItem('ACCESS_TOKEN');

	// if (token) {
	fetch(url, {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
			Authorization: `Bearer ${token}`
		},
		body: JSON.stringify(activity)
	}).then(res => res.json());
}
// }

function getUrl(url, key) {
	return window.AppConfig.API_URL[key] + url;
}

function generateGuestId() {
	const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
	let result = '';
	const charactersLength = characters.length;
	for (let i = 0; i < 16; i++) {
		result += characters.charAt(Math.floor(Math.random() * charactersLength));
	}
	return result;
}

async function getIpAddress() {
	try {
		const response = await fetch('https://ifconfig.me/ip');

		if (!response.ok) {
			throw new Error(`HTTP error! status: ${response.status}`);
		}

		const ipAddress = await response.text();
		return ipAddress;
	} catch (error) {
		console.error('Error fetching IP address:', error);
		return null;
	}
}

export async function recordActivity(action, page_title) {
	let guestID;
	const ipAddress = await getIpAddress();

	// Check localStorage for guest-id
	if (localStorage.getItem('guest-id')) {
		guestID = localStorage.getItem('guest-id');
	} else {
		// Generate a new guest-id if not found
		guestID = generateGuestId();

		// Store the generated guest-id in localStorage
		localStorage.setItem('guest-id', guestID);
	}

	// Now you can use the guestID variable

	const currentUser = JSON.parse(localStorage.getItem('CURRENT_USER_INFO'));

	const currentMoment = moment();

	const currentDate = currentMoment.format('YYYY-MM-DD'); // Date in 'YYYY-MM-DD' format
	const currentTime = currentMoment.format('hh:mm:ss A');

	let activity = {
		userid: currentUser ? `${currentUser.profile.id}` : `GUEST - ${guestID}`,
		ip_address: ipAddress,
		action,
		page_title,
		date_action: currentDate,
		time_action: currentTime,
		full_name: currentUser
			? currentUser.profile.name || `${currentUser.profile.first_name} ${currentUser.profile.last_name}`
			: 'NOT LOGIN'
	};

	const url = getUrl('action-logs/create', 'activitylogs');

	save(url, activity);
}

export const isDateDue = date => {
	const today = moment().startOf('day');
	const end = moment(new Date(date)).startOf('day');
	return end.isBefore(today);
};

export function getFirstDueInstallmentAndNext(installments) {
	// Find the index of the first installment with state set to 'DUE'
	const firstDueInstallmentIndex = installments.findIndex(installment => installment.state === 'DUE');

	// If a 'DUE' installment is found
	if (firstDueInstallmentIndex !== -1) {
		// Get the first due installment
		const firstDueInstallment = installments[firstDueInstallmentIndex];

		const overDueInstallments = installments.filter(
			installment => installment.state === 'DUE' && isDateDue(installment.installment_date)
		);

		let nextInstallment = installments[firstDueInstallmentIndex + 1];

		if (overDueInstallments.length > 0) {
			nextInstallment = installments
				.filter(installment => installment.state === 'DUE' && !isDateDue(installment.installment_date))
				.at(0);
		}

		if (!nextInstallment) {
			nextInstallment = firstDueInstallment; // temporary fix for when there is only one installment
		}

		// Return an object containing both the first due installment and the next installment
		return {
			firstDueInstallment,
			nextInstallment
		};
	}

	// If no 'DUE' installment is found, return null for both
	return {
		firstDueInstallment: null,
		nextInstallment: null
	};
}

export function getTotalInterestPaid(loanObject) {
	return loanObject.installments
		.filter(installment => !installment.hasOwnProperty('state') || installment.state !== 'SKIPPED') // if installment.state is not present, we must include it
		.reduce((total, installment) => +total + +installment.interest_part, 0);
	// return (
	// 	+loanObject.installments[0].remaining_amount + +loanObject.installments[0].emi_amount - +loanObject.principal
	// );
}

export const capitalizeFirstLetter = string => {
	return string.replace(/\w\S*/g, function (txt) {
		return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
	});
};

export const isOverDue = date => {
	// Date string to compare
	const dateToCompare = moment(date);

	const today = moment().startOf('day');

	// Determine if the installment_date is overdue
	return dateToCompare.isBefore(today);
};

export function validateBirthdate(birthDateStr) {
	// Handle empty or invalid date strings
	if (!birthDateStr || birthDateStr.trim() === '') {
		return 'Please enter your Birth Date.'; // Customize error message as needed
	}

	// Parse the birthdate string into a Date object
	const birthDate = new Date(birthDateStr);

	// Check if the birthDate is valid
	if (isNaN(birthDate.getTime())) {
		return 'Invalid birthdate format. Please enter a valid date.'; // Customize error message as needed
	}

	// Get today's date
	const today = new Date();

	// Calculate the minimum valid birthdate (exactly 18 years ago)
	const minBirthDate = new Date(today.getFullYear() - 18, today.getMonth(), today.getDate());

	// Calculate the maximum valid birthdate (no older than 100 years ago)
	const maxBirthDate = new Date(today.getFullYear() - 100, today.getMonth(), today.getDate());

	// Check if the birthdate is after the minimum valid date (younger than 18)
	if (birthDate > minBirthDate) {
		return 'You must be at least 18 years old to proceed.'; // Customize error message as needed
	}

	// Check if the birthdate is before the maximum valid date (older than 100)
	if (birthDate < maxBirthDate) {
		return 'Date should not be before minimal date.'; // Customize error message as needed
	}

	return ''; // No validation error
}

// window.amountFormate = amountFormate;
window.amountFormate = CommaSeparator;
window.GetFormat = GetFormat;
window.convertToViewableDate = convertToViewableDate;
window.checkIfPastOrPresentDate = checkIfPastOrPresentDate;
window.checkIfDateGreaterThanMaximumDate = checkIfDateGreaterThanMaximumDate;
window.checkIfDateIsOfPast = checkIfDateIsOfPast;
